<template>
  <div class="part-info">
    <label class="label">{{ label }}</label>
    <span>{{ value }}</span>
  </div>
</template>

<script>
export default {
  name: 'qcDefaultField',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      type: String,
      default: '--'
    }
  }
}
</script>

<style scoped lang="scss">
.part-info {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  font-size: var(--text-base);
  & .label {
    display: block;
    font-size: var(--text-s);
    color: #6b7280;
    margin-bottom: 6px;
  }
}
span {
  color: #333;
}
</style>
